var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-light continue-button btn-ripple-effect",class:_vm.size,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n\t"+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }